import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa"; // Import "Open Web" icon
import "./InTheNewsListing.css";
import WebViewCard from "../../components/commonComponent/WebViewCard";

const API_URL = process.env.REACT_APP_API_URL;

const InTheNewsWebView = () => {
  const [inthenews, setInTheNews] = useState([]);

  useEffect(() => {
    const fetchInTheNews = async () => {
      const response = await fetch(`${API_URL}/getAllNews`);
      const data = await response.json();
      console.log(data, "Fetched InTheNews");

      setInTheNews(data?.data || []);
    };

    fetchInTheNews();
  }, []);

  return (
    <div className="blog-listing" >
      <div className="blog-container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {inthenews.length > 0 ? (
          inthenews.map((inthenews_) => (
                      <WebViewCard  key={inthenews_.id} title={inthenews_.title} path={inthenews_.link} newWindow={true} />
          ))
        ) : (
          <p className="text-gray-600 text-center">Loading inthenewss...</p>
        )}
      </div>
    </div>
  );
};

export default InTheNewsWebView;
